import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';

const SUGGESTED_ACTION_QUESTION_QUERY_KEY = 'suggested-action-question';

type UseSuggestedActionQuestionProps = {
  dataRoomQuestionId?: string;
  drawer?: SideDrawerRef;
};

export default function useSuggestedActionQuestion({
  dataRoomQuestionId,
  drawer,
}: UseSuggestedActionQuestionProps) {
  const {
    data: question,
    refetch: getQuestion,
    isFetching,
  } = useQuery<Question>({
    queryKey: [SUGGESTED_ACTION_QUESTION_QUERY_KEY, dataRoomQuestionId],
    queryFn: async () => {
      if (!dataRoomQuestionId) return;

      const { data } = await dataRoomApi.questionsAndAnswers.getQuestion(
        dataRoomQuestionId,
      );

      return data;
    },
    enabled: false,
  });

  const openQuestionDrawer = useCallback(async () => {
    if (!dataRoomQuestionId || isFetching) return;

    const { data } = await getQuestion();

    if (data) drawer.setOpen(true);
  }, [dataRoomQuestionId, drawer, getQuestion, isFetching]);

  return {
    question,
    isFetching,
    openQuestionDrawer,
  };
}
